module.exports = "/packs/media/modules/welcome/welcome/faq/assets/billingFlow-15d85d0a04523003802a12e7ecc894be.jpg";